import type { Leg, Route, RouteKey } from "./types.js";

export const ROUTES: Record<RouteKey, Route> = {
  food: {
    name: "The Food Pilgrimage",
    cn: "美食纵贯线",
    cities: ["成都", "重庆", "西安", "潮州/汕头"],
  },
  adventure: { name: "The Cliff Circuit", cn: "山野冒险线", cities: ["华阴", "张家界", "丽江"] },
  family: { name: "The Pack Leader Loop", cn: "亲子线", cities: ["北京", "成都", "三亚"] },
  hidden: { name: "The Deep Cut", cn: "小众深度线", cities: ["黔东南", "红河", "潮州/汕头"] },
  contrast: { name: "The Contrast Line", cn: "反差线", cities: ["北京", "桂林", "阳朔", "上海"] },
  landscape: { name: "The Slow River", cn: "山水线", cities: ["桂林", "阳朔", "龙胜", "大理"] },
  metro: { name: "The Neon Corridor", cn: "都市霓虹线", cities: ["上海", "香港", "重庆"] },
  classic: { name: "The First-Timer Classic", cn: "经典首刷线", cities: ["北京", "西安", "上海"] },
};

// intercity legs: mode + hours — the "why these cities travel together" data
export const LEGS: Record<string, Leg> = {
  "成都|重庆": ["High-speed rail", 1.5],
  "重庆|西安": ["High-speed rail", 5],
  "西安|潮州/汕头": ["Flight", 2.5],
  "北京|成都": ["Flight", 3],
  "成都|三亚": ["Flight", 2.5],
  "北京|西安": ["High-speed rail", 4.5],
  "西安|上海": ["Flight", 2],
  "北京|桂林": ["Flight", 3],
  "桂林|阳朔": ["Private car", 1.5],
  "阳朔|龙胜": ["Private car", 3],
  "龙胜|大理": ["Flight", 1.5],
  "阳朔|上海": ["Flight", 2],
  "上海|香港": ["Flight", 2.5],
  "香港|重庆": ["Flight", 2.5],
  "华阴|张家界": ["High-speed rail", 4.5],
  "张家界|丽江": ["Flight", 2],
  "黔东南|红河": ["Rail + car", 5],
  "红河|潮州/汕头": ["Flight", 2.5],
};

export const legFor = (a: string, b: string): Leg =>
  LEGS[`${a}|${b}`] || LEGS[`${b}|${a}`] || (["Flight", null] as Leg);
export const fmtLeg = ([m, h]: Leg): string => (h ? `${m} · ${h}h` : `Direct ${m.toLowerCase()}`);
